import ActionType from "redux//action";
import initialStore from "redux/initialStore";

function configurationsReducer(state = initialStore.systemConfigs, action) {
  switch (action.type) {
    case ActionType.CHANGE_SYSTEM_CONFIG: {
      return {
        ...state,
        ...action.payload
      };
    }
    default:
      return state;
  }
}

export default configurationsReducer;
